export default "__VITE_ASSET__Cc79yh8I__"